var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Container',[_c('h1',[_vm._v("Matchs")]),_vm._l((_vm.matches),function(match){return _c('Match',{key:match.id,attrs:{"match":match}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }